import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCTS } from "@/data/catalog";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("es_cart")) || [];
    } catch {
      return [];
    }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("es_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (slug, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === slug);
      if (existing) {
        return prev.map((i) => (i.slug === slug ? { ...i, qty: Math.min(i.qty + qty, 20) } : i));
      }
      return [...prev, { slug, qty }];
    });
  };

  const setQty = (slug, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.slug !== slug));
    } else {
      setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, qty } : i)));
    }
  };

  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clearCart = () => setItems([]);

  const detailed = useMemo(
    () =>
      items
        .map((i) => {
          const product = PRODUCTS.find((p) => p.slug === i.slug);
          return product ? { ...product, qty: i.qty } : null;
        })
        .filter(Boolean),
    [items]
  );

  const total = useMemo(() => detailed.reduce((s, i) => s + i.price * i.qty, 0), [detailed]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  const buyNow = (slug) => {
    addItem(slug, 1);
    setCheckoutOpen(true);
  };

  return (
    <CartContext.Provider
      value={{
        items: detailed,
        count,
        total,
        addItem,
        setQty,
        removeItem,
        clearCart,
        buyNow,
        cartOpen,
        setCartOpen,
        checkoutOpen,
        setCheckoutOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
